import React from "react";
import ResultPageSection from "../../Sections/ResultPageSection/Content";
const ResultPage = () => {
  return <ResultPageSection />;
};

export default ResultPage;
